import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState } from 'react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui';
import { ChevronDownIcon } from 'lucide-react';
export function FunnelMultiSelect({ label, options, selected, onChange, placeholder = 'Все', emptyText = 'Пока нет вариантов', allowEmpty = true, disabled = false, className, }) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const listId = useId();
    useEffect(() => {
        if (disabled)
            setOpen(false);
    }, [disabled]);
    useEffect(() => {
        if (!open)
            return;
        const onPointer = (event) => {
            if (!rootRef.current?.contains(event.target))
                setOpen(false);
        };
        const onKey = (event) => {
            if (event.key === 'Escape')
                setOpen(false);
        };
        document.addEventListener('mousedown', onPointer);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onPointer);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);
    const summary = selected.length === 0
        ? placeholder
        : selected.length === 1
            ? (options.find((item) => item.value === selected[0])?.label ??
                selected[0])
            : `Выбрано: ${selected.length}`;
    return (_jsxs("div", { ref: rootRef, className: cn('relative min-w-44', className), children: [_jsx("span", { className: "mb-1 block text-[length:var(--unity-font-size-caption)] font-medium text-muted-foreground", children: label }), _jsxs(Button, { type: "button", variant: "outline", size: "sm", className: "h-9 min-h-9 w-full justify-between px-3 font-normal", "aria-expanded": open, "aria-controls": listId, disabled: disabled, onClick: () => {
                    if (disabled)
                        return;
                    setOpen((value) => !value);
                }, children: [_jsx("span", { className: "truncate text-left", children: summary }), _jsx(ChevronDownIcon, { className: "size-4 shrink-0 opacity-60" })] }), open ? (_jsx("ul", { id: listId, className: "absolute top-full left-0 z-30 mt-1 max-h-56 w-full min-w-[14rem] overflow-y-auto rounded-[var(--unity-radius)] border border-border bg-card p-1 shadow-md", role: "listbox", "aria-multiselectable": true, children: options.length === 0 ? (_jsx("li", { className: "px-2 py-1.5 text-[length:var(--unity-font-size-caption)] text-muted-foreground", children: emptyText })) : (options.map((option) => {
                    const checked = selected.includes(option.value);
                    return (_jsx("li", { role: "option", "aria-selected": checked, children: _jsxs("label", { className: "flex min-h-9 cursor-pointer items-center gap-2 rounded-[var(--unity-radius)] px-2 text-sm hover:bg-accent", children: [_jsx("input", { type: "checkbox", className: "size-4 accent-[var(--unity-color-brand)]", checked: checked, onChange: () => {
                                        const next = checked
                                            ? selected.filter((item) => item !== option.value)
                                            : [...selected, option.value];
                                        if (!allowEmpty && next.length === 0)
                                            return;
                                        onChange(next);
                                    } }), _jsx("span", { className: "truncate", children: option.label })] }) }, option.value));
                })) })) : null] }));
}
